export const umbracoImageLoader = ({ src, width }: { src: string; width: number }) => {
  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return src;
  }

  url.searchParams.set('rmode', 'max');
  url.searchParams.set('width', String(width));
  url.searchParams.delete('height');
  return url.toString();
};
